export default "__VITE_ASSET__0xwS5dIz__"